import {AbstractFormFieldComponent} from "./abstract-form-field.component";
import {isDefined, nonBlank, unsubscribe} from "../utils/epic.utils";
import {FormWrapper} from "./items/form.wrapper";
import {FormRadiosConfig} from "./form-radios/form-radios.config";
import {FormSelectConfig} from "./form-select/form-select.config";
import {FormSelectOption} from "./items/form-select-option";
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {Subscription} from "rxjs";
import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from "@angular/core";

@Component({standalone: true, changeDetection: ChangeDetectionStrategy.Eager,
 template: ''})
export abstract class AbstractFormSelectFieldComponent extends AbstractFormFieldComponent implements OnInit, OnDestroy {

  protected readonly subs: Subscription[] = [];
  protected selectedName: string | undefined;
  protected selectOptions: FormSelectOption[] = [];
  protected tooltipName: string | undefined;

  protected abstract getName(): string;

  protected abstract getWrapper(): FormWrapper;

  protected abstract getConfig(): FormSelectConfig | FormRadiosConfig;

  protected abstract getTooltip(): NgbTooltip | undefined;

  ngOnInit(): void {
    this.fieldOptionsInit();
    this.accOnInit();
  }

  ngOnDestroy(): void {
    this.accOnDestroy();
    unsubscribe(this.subs);
  }


  public setInitValue(forceInit: boolean = false): void {
    // removed from if: this.wrapper.getSelectOptions(this.name).length > 0
    if (this.getWrapper().hasControl(this.getName()) && (forceInit || !this.hasSelectedOptions())) {
      const oldValue: any = this.getWrapper().getValue(this.getName());
      const defaultOption: FormSelectOption | undefined = this.getWrapper().getDefaultOption(this.getName());
      if (isDefined(defaultOption)) {
        this._onChangeValue(this.getName(), this.getWrapper(), defaultOption.value, oldValue, true);
        this.updateSelectedByOption(defaultOption);
      } else if (this.getConfig().selectFirstIfEmpty && this.selectOptions.length > 0) {
        const fistOption: FormSelectOption = this.selectOptions[0];
        if (isDefined(fistOption)) {
          this._onChangeValue(this.getName(), this.getWrapper(), fistOption.value, oldValue, true);
          this.updateSelectedByOption(fistOption);
        } else {
          this._onChangeValue(this.getName(), this.getWrapper(), undefined, oldValue, true);
          this.updateSelectedByOption(undefined);
        }
      }
    }
  }

  protected fieldOptionsInit(forceInit: boolean = false): void {
    this.subs.push(this.getWrapper().onReady().subscribe(() => {
      if (this.getWrapper().hasAsyncSelectOptions(this.getName())) {
        const asyncDataFn = this.getWrapper().getAsyncSelectOptions(this.getName());
        if (isDefined(asyncDataFn)) {
          this.subs.push(asyncDataFn('').subscribe((o) => {
            this.selectOptions = o;
            this.setInitValue(forceInit);
          }));
        }
      } else {
        this.selectOptions = this.getWrapper().getSelectOptions(this.getName());
        this.setInitValue(forceInit);
      }
    }));
  }


  protected hasSelectedOptions(): boolean {
    return nonBlank(this.selectedName) || this._hasSelectedOptions(this.getName(), this.getWrapper());
  }

  protected updateSelectedByOption(option: FormSelectOption | undefined): void {
    if (isDefined(option)) {
      this.selectedName = option.hasTranslation() ? this.i18n.translate(option.translation) : option.name;
    } else {
      this.selectedName = undefined;
    }

    if (this.getConfig().showSelectedNameTooltip) {
      this.tooltipName = this.selectedName;
      this.getTooltip()?.close();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  protected accOnInit(): void {
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  protected accOnDestroy(): void {
  }
}
